import { render } from "./AddAddressOfNei.vue?vue&type=template&id=2f7c4e70&scoped=true"
import script from "./AddAddressOfNei.vue?vue&type=script&lang=ts"
export * from "./AddAddressOfNei.vue?vue&type=script&lang=ts"

import "./AddAddressOfNei.vue?vue&type=style&index=0&id=2f7c4e70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f7c4e70"

export default script